<template>
<div id="contents">
</div><!-- #contents -->
</template>

<script>
export default {
  name: 'recruit_2025_redirect',
  mounted () {
    const ts = this
    setTimeout(function(){
      ts.$emit('page_fade')
      window.location.href = '/sp/#/recruit_2026';
    },ts.$parent.page_load_time)
  }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/recruit_2025_redirect.vue